import { createSelector } from '@reduxjs/toolkit';
import { EMetroTravelType } from '../../../../packages/api-models/common/json_query';
import { selectTravelType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  {
    value: EMetroTravelType.MapFoot,
    label: 'Пешком',
  },
  {
    value: EMetroTravelType.MapTransport,
    label: 'Транспортом',
  },
];

export const selectTravelTypeFilter = createSelector(selectTravelType, value => ({
  value: [value],
  options: OPTIONS,
}));
